import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickApiOutput from '@/components/brick_api_output.vue'

let infos = new BrickInfos()

infos.output = '   '
infos.back_classes = ['fas', 'fa-square', 'text-red']
infos.front_classes = ['fas', 'far fa-brackets-curly', 'text-white']
infos.name = 'api_output'
infos.associated_class_name = 'AutomlApiOutput'
infos.editing_component_name = 'BrickApiOutput'
infos.editing_component = BrickApiOutput
infos.summary_component_name = ''
infos.summary_component = undefined
infos.element_preview_type = 'JsonViewer'
infos.descriptions = {
	en: {
		short_tooltip_description: 'API Output',
		full_tooltip_description: 'Send data through API connection',
		navbar_name: 'API Output',
	},
	fr: {
		short_tooltip_description: 'Sortie API',
		full_tooltip_description: 'Envoi de données grâce à la connexion API',
		navbar_name: 'Sortie API',
	},
}
// infos.short_tooltip_description = 'api_output_short_tooltip'
// infos.full_tooltip_description = 'api_output_full_tooltip'
// infos.navbar_name = 'api_output_navbar'
infos.background_color = 'red'

brick_registerer(infos)
